import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  signal,
  DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzMessageService } from 'ng-zorro-antd/message';
import { EmpleadoService } from '@services/empleado.service';
import { Empleado } from '@schemas/empleado.schema';

import { DetailField } from '../../../components/detail-field/detail-field';

import { PageActions, PageHeader, SectionHeader, StatusText } from '@intelishs-group/ui';

@Component({
  selector: 'app-empleado-detalle',
  imports: [
    DetailField,
    DatePipe,
    DecimalPipe,
    NzIconModule,
    NzButtonModule,
    NzTooltipModule,
    PageActions,
    PageHeader,
    SectionHeader,
    StatusText,
  ],
  templateUrl: './empleado-detalle.page.html',
  styleUrl: './empleado-detalle.page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmpleadoDetallePage implements OnInit {
  private readonly empleadoService = inject(EmpleadoService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly message = inject(NzMessageService);
  private readonly destroyRef = inject(DestroyRef);

  empleado = signal<Empleado | null>(null);
  loading = signal(true);
  /** true cuando el empleado es provisional (aún no está en BD) */
  provisional = signal(false);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.cargarEmpleado(+id);
    }
  }

  private cargarEmpleado(id: number): void {
    this.empleadoService
      .getById(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (emp) => {
          this.empleado.set(emp);
          this.provisional.set(emp.id === -1);
          this.loading.set(false);
        },
        error: () => {
          this.message.error('Error al cargar el empleado');
          this.loading.set(false);
        },
      });
  }

  editar(): void {
    const emp = this.empleado();
    if (!emp || this.provisional()) {
      this.message.warning(
        'Este empleado aún no está en la base de datos. El DBA debe agregarlo primero.',
      );
      return;
    }
    this.router.navigate(['/empleados/editar', emp.id]);
  }

  volver(): void {
    this.router.navigate(['/empleados']);
  }
}
